// extracted by mini-css-extract-plugin
export var bodyRow = "_f6-d";
export var cardColumns = "_f6-e";
export var ellipsesOverflow = "_f6-2";
export var flatBottomCorners = "_f6-3";
export var flatTopCorners = "_f6-4";
export var headerActionsDropdown = "_f6-f";
export var headerBottomRow = "_f6-c";
export var headerTopRow = "_f6-b";
export var orderDetailsWrapper = "_f6-0";
export var orderInfoContainer = "_f6-1";
export var productDetails = "_f6-9";
export var productImage = "_f6-5";
export var responsiveTable = "_f6-8";
export var shipmentContainer = "_f6-a";
export var tableBottomLeft = "_f6-6";
export var tableBottomRight = "_f6-7";
export var trackingLink = "_f6-g";